import { ApiUrl } from "../../../Constants/Api";
import {
  REQUEST_METHOD,
  WebService,
} from "../../WebServiceManager/RequestService";
import ProfileRequestBody from "./ProfileRequestBody";

export default class ProfileService {
  request = new ProfileRequestBody();
  static shared = new ProfileService();

  updateprofileUserRequest = (payload) => {

  return new Promise((resolve, reject) => {
    WebService.clientShared
      .callServiceApi(
        ApiUrl.updateProfileUser(),  // Ensure payload is NOT passed inside URL
        this.request.updateProfileUserRequest(REQUEST_METHOD.PUT, payload.user)
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
}
